import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'

const P = '/mang-xa-hoi'

// Lấy tài liệu bài viết
export function layTaiLieuBaiViet(postId: number) {
  try {
    return axiosApi.get(`${P}/bai-dang/${postId}/dinh-kem`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Thêm tài liệu bài viết
export function themTaiLieuBaiViet(postId: number, params: any) {
  try {
    return axiosApi.post(`${P}/bai-dang/${postId}/dinh-kem`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa tài liệu bài viết
export function xoaTaiLieuBaiViet(attachmentId: number) {
  try {
    return axiosApi.delete(`${P}/dinh-kem/${attachmentId}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
